<script>
import VsAlert from 'viralstyle-ui/src/VsAlert';
import VsLogoLoader from 'viralstyle-ui/src/VsLogoLoader';

import CollectionSort from './CollectionSort';
import CollectionPagination from './CollectionPagination';
import CollectionFilters from './CollectionFilters';
import CollectionBanner from './CollectionBanner';
import ProductGroup from './ProductGroup';

export default {
  components: {
    VsAlert,
    VsLogoLoader,
    ProductGroup,
    CollectionSort,
    CollectionPagination,
    CollectionFilters,
    CollectionBanner,
  },
  props: {
    info: Object,
    campaigns: Array,
    currencyInfo: Object,
    processing: Boolean,
    page: String,
    isWhitelabel: Boolean,
    sortOptions: Array,
    selectedProductType: String,
    selectedSortText: String,
    selectedCategory: Object,
    selectedParentCategory: Object,
    selectedSubCategory: Object,
    selectedSubSubCategory: Object,
    formattedProductType: String,
    categories: Object,
    productTypes: Array,
    pages: Array,
    maxPages: Number,
    showSortAndFilter: Boolean,
    routeName: String,
    alternateImage: String,
    coupon: String,
    showMobileFilterModal: Boolean,
    showMobileSortModal: Boolean,
    utmSource: String,
    affiliate: String,
  },
  mounted() {
    this.$emit('view-collection');
  },
};
</script>

<template lang='pug'>
div(v-if='showSortAndFilter')

  collection-banner(
    v-if='info',
    :info='info',
    :alternate-image='alternateImage',
  )

  .container.mx-auto.mb-5.mt-1_5
    collection-sort(
      :sort-options='sortOptions',
      :selected-product-type='selectedProductType',
      :selected-sort-text='selectedSortText',
      :selected-category='selectedCategory',
      :selected-parent-category='selectedParentCategory',
      :selected-sub-category='selectedSubCategory',
      :selected-sub-sub-category='selectedSubSubCategory',
      :formatted-product-type='formattedProductType',
      :categories='categories',
      :product-types='productTypes',
      :show-mobile-filter-modal='showMobileFilterModal',
      :show-mobile-sort-modal='showMobileSortModal',
      @update-state='$emit("update-state", $event)',
      @lock-scroll='$emit("lock-scroll", $event)',
      @get-campaigns='$emit("get-campaigns")',
    )

    .flex.flex-wrap.items-start
      .w-2-12.hidden.md_block
        collection-filters(
          :selected-category='selectedCategory',
          :selected-product-type='selectedProductType',
          :categories='categories',
          :product-types='productTypes',
          @update-state='$emit("update-state", $event)',
          @get-campaigns='$emit("get-campaigns")',
        )

      .flex.flex-wrap.w-full.md_w-10-12.md_border-l.md_border-brand-secondary-75.px-1.pt-1.md_pt-2.md_px-2
        product-group(
          v-if='campaigns.length && !processing',
          wrap,
          three-columns,
          :utm-source='utmSource',
          :campaigns='campaigns',
          :currency-info='currencyInfo',
          :is-whitelabel='isWhitelabel',
          :coupon='coupon',
          :affiliate='affiliate',
          @hide-campaign='$emit("hide-campaign", $event)',
        )
        template(v-else-if='maxPages === 0 && !processing')
          vs-alert(
            v-if='routeName === "collection"',
            message='This collection does not contain any products',
            type='table',
          )
          .text-4xl.text-brand.mx-auto.mt-5(v-else-if='routeName === "marketplace"') No Results Found...
        .h-6.mx-auto.mt-5(v-else)
          vs-logo-loader(
            :is-whitelabel='isWhitelabel',
            slow,
          )

      .w-2-12.hidden.md_block
      .w-full.md_w-10-12
        collection-pagination(
          :processing='processing',
          :page='page',
          :pages='pages',
          :max-pages='maxPages',
          @get-campaigns='$emit("get-campaigns", $event)',
        )

div(v-else)

  collection-banner(
    v-if='info',
    :info='info',
    :alternate-image='alternateImage',
  )

  .container.mx-auto.my-4
    template(v-if='campaigns.length')
      product-group(
        wrap,
        :utm-source='utmSource',
        :campaigns='campaigns',
        :currency-info='currencyInfo',
        :is-whitelabel='isWhitelabel',
        :coupon='coupon',
        :affiliate='affiliate',
      )
      .w-full
        collection-pagination(
          :processing='processing',
          :page='page',
          :pages='pages',
          :max-pages='maxPages',
          @get-campaigns='$emit("get-campaigns", $event)',
        )
    vs-alert(
      v-else,
      message='This collection does not contain any products',
      type='table',
    )
</template>

<style>
@import '~import/index';

.collection {
  &__description {
    img {
      opacity: 1;
      max-width: 100%;
    }

    a {
      color: $primaryColor;

      &:hover,
      &:active {
        text-decoration: underline;
      }
    }
  }
}
</style>